<div
  class="editor-wrapper"
  [class.disabled]="disabled"
  [class.source-only]="sourceOnly"
  [style.height.px]="height"
>
  <div class="editor-main">
    <div class="editor-toolbar" *ngIf="!sourceOnly">
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn source-btn" [class.active]="showSource" (click)="toggleSource()" title="View Source Code">
        <mat-icon>code</mat-icon>
        <span>Source</span>
      </button>
    </div>

    <div class="toolbar-divider"></div>

      <div class="toolbar-group">
        <button type="button" class="toolbar-btn-with-label" (click)="undo()" title="Undo (Ctrl+Z)">
          <mat-icon>undo</mat-icon>
          <span class="toolbar-label">Undo</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" (click)="redo()" title="Redo (Ctrl+Y)">
          <mat-icon>redo</mat-icon>
          <span class="toolbar-label">Redo</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" (click)="clear()" title="Clear">
          <mat-icon>delete_sweep</mat-icon>
          <span class="toolbar-label">Clear</span>
        </button>
      </div>

    <div class="toolbar-divider"></div>

    <ng-container *ngIf="!showSource">
      <div class="toolbar-group">
        <select (change)="onSelectChange('fontName', $event)" [value]="currentFontName" class="toolbar-select font-family-select">
          <option value="" disabled selected>Font</option>
          <option *ngFor="let font of fontFamilies" [value]="font.value">{{font.name}}</option>
        </select>
        
        <select (change)="onSelectChange('fontSize', $event)" [value]="currentFontSize" class="toolbar-select font-size-select">
          <option value="" disabled selected>Size</option>
          <option *ngFor="let size of fontSizes" [value]="size.value">{{size.name}}</option>
        </select>
      </div>

      <div class="toolbar-divider"></div>

      <div class="toolbar-group">
        <button type="button" class="toolbar-btn-with-label" [class.active]="isBold" (click)="execCommand('bold')" title="Bold">
          <mat-icon>format_bold</mat-icon>
          <span class="toolbar-label">BOLD</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" [class.active]="isItalic" (click)="execCommand('italic')" title="Italic">
          <mat-icon>format_italic</mat-icon>
          <span class="toolbar-label">ITALIC</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" [class.active]="isUnderline" (click)="execCommand('underline')" title="Underline">
          <mat-icon>format_underlined</mat-icon>
          <span class="toolbar-label">UNDERLINE</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <div class="toolbar-group">
        <div class="color-picker-wrapper" title="Text Color">
          <label for="foreColorPicker" class="color-picker-label">
            <mat-icon>format_color_text</mat-icon>
          </label>
          <input id="foreColorPicker" type="color" (change)="onColorChange('setTextColor', $event)" [value]="getCurrentTextColor()">
          <button type="button" class="color-reset-btn" *ngIf="hasTextColor()" (click)="removeTextColor(); $event.stopPropagation()" title="Remove Text Color">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        
        <div class="color-picker-wrapper" title="Background Color">
           <label for="hiliteColorPicker" class="color-picker-label">
            <mat-icon>format_color_fill</mat-icon>
          </label>
          <input id="hiliteColorPicker" type="color" (change)="onColorChange('setBackgroundColor', $event)" [value]="getCurrentBackgroundColor()">
          <button type="button" class="color-reset-btn" *ngIf="hasBackgroundColor()" (click)="removeBackgroundColor(); $event.stopPropagation()" title="Remove Background Color">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="toolbar-divider"></div>

      <div class="toolbar-group">
        <button type="button" class="toolbar-btn-with-label" [class.active]="isJustifyLeft" (click)="execCommand('justifyLeft')" title="Align Left">
          <mat-icon>format_align_left</mat-icon>
          <span class="toolbar-label">L</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" [class.active]="isJustifyCenter" (click)="execCommand('justifyCenter')" title="Align Center">
          <mat-icon>format_align_center</mat-icon>
          <span class="toolbar-label">C</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" [class.active]="isJustifyRight" (click)="execCommand('justifyRight')" title="Align Right">
          <mat-icon>format_align_right</mat-icon>
          <span class="toolbar-label">R</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <div class="toolbar-group">
        <button type="button" class="toolbar-btn-with-label" [class.active]="currentCellValign === 'top'" (click)="execValign('top')" title="Vertical Align Top">
          <mat-icon>vertical_align_top</mat-icon>
          <span class="toolbar-label">T</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" [class.active]="currentCellValign === 'middle'" (click)="execValign('middle')" title="Vertical Align Middle">
          <mat-icon>vertical_align_center</mat-icon>
          <span class="toolbar-label">M</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" [class.active]="currentCellValign === 'bottom'" (click)="execValign('bottom')" title="Vertical Align Bottom">
          <mat-icon>vertical_align_bottom</mat-icon>
          <span class="toolbar-label">B</span>
        </button>
      </div>

      <div class="toolbar-divider"></div>

      <div class="toolbar-group">
        <button type="button" class="toolbar-btn-with-label" (click)="insertTable()" title="Insert Table (2x2)">
          <mat-icon>grid_on</mat-icon>
          <span class="toolbar-label">Table</span>
        </button>
        
        <button type="button" 
                class="toolbar-btn-with-label" 
                [class.active]="showTableProperties || showCellProperties" 
                (click)="toggleTableProperties()" 
                title="Table/Cell Properties"
                *ngIf="hasTableInEditor || selectedCell">
          <mat-icon>settings</mat-icon>
          <span class="toolbar-label">Props</span>
        </button>
        
        <ng-container *ngIf="selectedCell">
            <button type="button" class="toolbar-btn-with-label" (click)="insertNestedTable()" title="Insert Nested Table">
                <mat-icon>playlist_add</mat-icon>
                <span class="toolbar-label">Nested</span>
            </button>
            <button type="button" class="toolbar-btn-with-label" (click)="mergeCells()" title="Merge with adjacent cell">
                <mat-icon>merge</mat-icon>
                <span class="toolbar-label">Merge</span>
            </button>
            <button type="button" class="toolbar-btn-with-label" (click)="splitCell()" title="Split Cell">
                <mat-icon>call_split</mat-icon>
                <span class="toolbar-label">Split</span>
            </button>
            <button type="button" class="toolbar-btn-with-label" (click)="insertRow('after')" title="Insert Row After">
                <mat-icon>table_rows</mat-icon>
                <span class="toolbar-label">Row+</span>
            </button>
            <button type="button" class="toolbar-btn-with-label" (click)="insertColumn('after')" title="Insert Column After">
                <mat-icon>view_column</mat-icon>
                <span class="toolbar-label">Col+</span>
            </button>
            <button type="button" class="toolbar-btn-with-label" (click)="deleteRow()" title="Delete Row">
              <mat-icon>delete_sweep</mat-icon>
              <span class="toolbar-label">Row-</span>
            </button>
             <button type="button" class="toolbar-btn-with-label" (click)="deleteColumn()" title="Delete Column">
              <mat-icon>delete_outline</mat-icon>
              <span class="toolbar-label">Col-</span>
            </button>
            <button type="button" class="toolbar-btn-with-label reset-btn" (click)="deleteTable()" title="Delete Entire Table">
                <mat-icon>delete_forever</mat-icon>
                <span class="toolbar-label">Del</span>
            </button>
        </ng-container>
      </div>
      
      <div class="toolbar-divider"></div>

      <div class="toolbar-group">
        <button type="button" class="toolbar-btn-with-label" [class.active]="showLinkInput" (click)="insertLink()" title="Insert Link">
          <mat-icon>link</mat-icon>
          <span class="toolbar-label">Link</span>
        </button>
        <button type="button" class="toolbar-btn-with-label" (click)="execCommand('unlink')" title="Remove Link">
          <mat-icon>link_off</mat-icon>
          <span class="toolbar-label">Unlink</span>
        </button>
         <button type="button" class="toolbar-btn-with-label" [class.active]="showImageInput" (click)="insertImage()" title="Insert Image">
          <mat-icon>image</mat-icon>
          <span class="toolbar-label">Image</span>
        </button>
      </div>
    </ng-container>
    </div>

    <div class="editor-properties" *ngIf="(showTableProperties && selectedTable) || (showCellProperties && selectedCell) || showLinkInput || showImageInput">
    <div class="sidebar-content">
      <ng-container *ngIf="showTableProperties && selectedTable">
        <div class="toolbar-group">
          <label class="properties-label" title="Table width">Width</label>
          <input type="text" 
             [value]="selectedTable?.style?.width || selectedTable?.getAttribute('width') || ''" 
             (input)="onStyleInputChange('tableWidth', $event)" 
             placeholder="100%"
             class="sidebar-input"
             style="min-width: 70px;"
             title="Table width">
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Table height">Height</label>
          <input type="text" 
             [value]="selectedTable?.style?.height || selectedTable?.getAttribute('height') || ''" 
             (input)="onStyleInputChange('tableHeight', $event)" 
             placeholder="Auto"
             class="sidebar-input"
             style="min-width: 70px;"
             title="Table height">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Collapse borders">Collapse</label>
          <input type="checkbox" 
                 [checked]="getTableBorderCollapse()" 
                 (change)="updateTableBorderCollapse($any($event.target).checked)"
                 title="Collapse borders">
        </div>
        <div class="toolbar-group" *ngIf="!getTableBorderCollapse()">
          <label class="properties-label" title="Border spacing">Spacing</label>
          <input type="text" 
             [value]="selectedTable?.style?.borderSpacing || ''" 
             (input)="onStyleInputChange('tableBorderSpacing', $event)" 
             placeholder="0px"
             class="sidebar-input"
             style="min-width: 55px;"
             title="Border spacing">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Background image">BG Image</label>
          <input type="text" 
             [value]="selectedTable?.style?.backgroundImage?.replace('url(&quot;', '')?.replace('&quot;)', '')?.replace('url(', '')?.replace(')', '') || ''" 
             (input)="onStyleInputChange('bgImage', $event, 'table')" 
             placeholder="URL"
             class="sidebar-input"
             style="min-width: 130px;"
             title="Background image URL">
        </div>
        <div class="toolbar-group" *ngIf="selectedTable?.style?.backgroundImage">
          <label class="properties-label" title="Background position">Pos</label>
          <select class="sidebar-select" (change)="onStyleInputChange('bgPosition', $event, 'table')" [value]="selectedTable?.style?.backgroundPosition || 'initial'">
            <option value="initial">Default</option>
            <option value="center">Center</option>
            <option value="top">Top</option>
            <option value="bottom">Bottom</option>
            <option value="left">Left</option>
            <option value="right">Right</option>
          </select>
        </div>
      </ng-container>
      <div class="toolbar-divider" *ngIf="(showTableProperties && selectedTable) && (showCellProperties || showLinkInput || showImageInput)"></div>
      <ng-container *ngIf="showLinkInput">
        <div class="toolbar-group">
          <label class="properties-label" title="Link URL">URL</label>
          <input type="text" [(ngModel)]="linkInputUrl" class="sidebar-input" placeholder="https://" (keyup.enter)="applyLink()" style="min-width: 150px;" title="Link URL">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Remove underline">No Underline</label>
          <input type="checkbox" (change)="updateLinkStyle('textDecoration', $any($event.target).checked ? 'none' : 'underline')" title="Remove underline">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Link color">Color</label>
          <input type="color" 
                 (change)="updateLinkStyle('color', $any($event.target).value)" 
                 class="sidebar-color-picker"
                 title="Link text color">
        </div>
        <div class="toolbar-spacer"></div>
        <div class="toolbar-group">
          <button type="button" class="sidebar-btn-apply" (click)="applyLink()" title="Apply Link">
            <span>Apply</span>
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </ng-container>
      <div class="toolbar-divider" *ngIf="showLinkInput && (showCellProperties || showImageInput)"></div>
      <ng-container *ngIf="showImageInput">
        <div class="toolbar-group">
          <label class="properties-label" title="Image URL">URL</label>
          <input type="text" [(ngModel)]="imageInputUrl" class="sidebar-input" placeholder="https://" (keyup.enter)="applyImage()" style="min-width: 150px;" title="Image URL">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Alternative text">Alt</label>
          <input type="text" [(ngModel)]="imageInputAlt" class="sidebar-input" placeholder="Alt" (keyup.enter)="applyImage()" style="min-width: 80px;" title="Alternative text">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Image width">Width</label>
          <input type="text" [(ngModel)]="imageInputWidth" class="sidebar-input" placeholder="Auto" (keyup.enter)="applyImage()" style="min-width: 60px;" title="Image width">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Image link (href)">Link</label>
          <input type="text" [(ngModel)]="imageInputHref" class="sidebar-input" placeholder="https://" (keyup.enter)="applyImage()" style="min-width: 150px;" title="Image link URL">
        </div>
        <div class="toolbar-spacer"></div>
        <div class="toolbar-group">
          <button type="button" class="sidebar-btn-apply" (click)="applyImage()" title="Apply Image">
            <span>Apply</span>
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </ng-container>
      <div class="toolbar-divider" *ngIf="showImageInput && showCellProperties"></div>
      <ng-container *ngIf="showCellProperties && selectedCell">
        <div class="toolbar-group">
          <label class="properties-label" title="Cell width">W</label>
          <input type="text" 
             [value]="selectedCell.style.width || selectedCell.getAttribute('width') || ''" 
             (input)="onStyleInputChange('cellWidth', $event)" 
             placeholder="Auto"
             class="sidebar-input"
             title="Cell width">
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Cell height">H</label>
          <input type="text" 
             [value]="selectedCell.style.height || selectedCell.getAttribute('height') || ''" 
             (input)="onStyleInputChange('cellHeight', $event)" 
             placeholder="Auto"
             class="sidebar-input"
             title="Cell height">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Column span">Col</label>
          <input type="number" min="1"
             [value]="selectedCell.colSpan" 
             (input)="updateColSpan($any($event.target).value)" 
             class="sidebar-input"
             title="Column span">
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Row span">Row</label>
          <input type="number" min="1"
             [value]="selectedCell.rowSpan" 
             (input)="updateRowSpan($any($event.target).value)" 
             class="sidebar-input"
             title="Row span">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Padding top">P-T</label>
          <input type="text" [value]="selectedCell.style.paddingTop || ''" (input)="onStyleInputChange('cellPaddingTop', $event)" placeholder="T" class="sidebar-input" style="min-width: 35px;" title="Padding top">
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Padding right">P-R</label>
          <input type="text" [value]="selectedCell.style.paddingRight || ''" (input)="onStyleInputChange('cellPaddingRight', $event)" placeholder="R" class="sidebar-input" style="min-width: 35px;" title="Padding right">
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Padding bottom">P-B</label>
          <input type="text" [value]="selectedCell.style.paddingBottom || ''" (input)="onStyleInputChange('cellPaddingBottom', $event)" placeholder="B" class="sidebar-input" style="min-width: 35px;" title="Padding bottom">
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Padding left">P-L</label>
          <input type="text" [value]="selectedCell.style.paddingLeft || ''" (input)="onStyleInputChange('cellPaddingLeft', $event)" placeholder="L" class="sidebar-input" style="min-width: 35px;" title="Padding left">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Line height">LH</label>
          <input type="text" 
             [value]="selectedCell.style.lineHeight || ''" 
             (input)="onStyleInputChange('lineHeight', $event)" 
             placeholder="Auto"
             class="sidebar-input"
             style="min-width: 50px;"
             title="Line height">
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group" style="display: flex; align-items: center; gap: 4px;">
          <label class="properties-label" title="Background color">BG</label>
          <div class="sidebar-color-picker-wrapper" style="display: inline-flex; align-items: center;">
            <input type="color" 
                   [value]="getCellBackgroundColor()" 
                   (change)="onColorChange('setCellBackgroundColor', $event)"
                   class="sidebar-color-picker"
                   title="Background color">
            <button type="button" 
                    class="color-reset-btn" 
                    *ngIf="hasCellBackgroundColor()"
                    (click)="removeCellBackgroundColor(); $event.stopPropagation()" 
                    title="Remove background color">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Background image">BG Img</label>
          <input type="text" 
             [value]="selectedCell.style.backgroundImage?.replace('url(&quot;', '')?.replace('&quot;)', '')?.replace('url(', '')?.replace(')', '') || ''" 
             (input)="onStyleInputChange('bgImage', $event, 'cell')" 
             placeholder="URL"
             class="sidebar-input"
             style="min-width: 120px;"
             title="Background image URL">
        </div>
        <div class="toolbar-group" *ngIf="selectedCell.style.backgroundImage">
          <label class="properties-label" title="Background position">Pos</label>
          <select class="sidebar-select" (change)="onStyleInputChange('bgPosition', $event, 'cell')" [value]="selectedCell.style.backgroundPosition || 'initial'">
            <option value="initial">Default</option>
            <option value="center">Center</option>
            <option value="top">Top</option>
            <option value="bottom">Bottom</option>
            <option value="left">Left</option>
            <option value="right">Right</option>
          </select>
        </div>
        <div class="toolbar-divider"></div>
        <div class="toolbar-group">
          <label class="properties-label" title="Border width">W</label>
          <input type="text" #borderWidthVal [value]="getCellBorderWidth()" placeholder="1" class="sidebar-input-small" title="Border width" (input)="updateCellBorder(borderSideVal.value, borderWidthVal.value, borderStyleVal.value, borderColorVal.value)">
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Border style">Style</label>
          <select #borderStyleVal class="sidebar-select" [value]="getCellBorderStyle()" style="min-width: 65px;" (change)="updateCellBorder(borderSideVal.value, borderWidthVal.value, borderStyleVal.value, borderColorVal.value)">
            <option value="solid">Solid</option>
            <option value="dashed">Dashed</option>
            <option value="dotted">Dotted</option>
          </select>
        </div>
        <div class="toolbar-group" style="display: flex; align-items: center; gap: 4px;">
          <label class="properties-label" title="Border color">Color</label>
          <div class="sidebar-color-picker-wrapper" style="display: inline-flex; align-items: center;">
            <input type="color" 
                   #borderColorVal 
                   [value]="getCellBorderColor()" 
                   class="sidebar-color-picker" 
                   title="Border color"
                   (change)="updateCellBorder(borderSideVal.value, borderWidthVal.value, borderStyleVal.value, borderColorVal.value)">
            <button type="button" 
                    class="color-reset-btn" 
                    *ngIf="hasCellBorder()"
                    (click)="removeCellBorder(); $event.stopPropagation()" 
                    title="Remove border">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <div class="toolbar-group">
          <label class="properties-label" title="Border side">Side</label>
          <select #borderSideVal class="sidebar-select" style="min-width: 55px;" (change)="updateCellBorder(borderSideVal.value, borderWidthVal.value, borderStyleVal.value, borderColorVal.value)">
            <option value="all">All</option>
            <option value="left">Left</option>
            <option value="right">Right</option>
            <option value="top">Top</option>
            <option value="bottom">Bottom</option>
            <option value="none">None</option>
          </select>
        </div>
      </ng-container>
    </div>
    </div>

    <div
      class="editor-content-area"
      #editor
      *ngIf="!sourceOnly && !showSource"
      contenteditable="true"
      (input)="onInput()"
      (blur)="onTouched()"
    ></div>

    <div
      *ngIf="sourceOnly || showSource"
      #monacoContainer
      class="monaco-editor-container"
      [class.monaco-editor-container--full]="sourceOnly"
      (keydown.enter)="$event.stopPropagation()"
    ></div>
  </div>
</div>

